module.exports = __webpack_public_path__ + "fonts/NotoSansJP-VariableFont_wght.ace7a5cb.ttf";